import { createRoute, lazyRouteComponent, notFound, redirect } from '@tanstack/react-router'
import { shellRoute } from './index'
import { isStudioSection } from '@/shared/config'
import { studioSearchSchema } from '../search'

/** `/studio` сам по себе не экран — уводим на первый раздел списка, «Сценарии». */
export const studioIndexRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/studio',
  beforeLoad: () => {
    throw redirect({ to: '/studio/$section', params: { section: 'scenarios' } })
  },
})

/**
 * Список валидных разделов — `shared/config/studio-sections.ts`, не здесь: страница грузится
 * лениво (см. `component` ниже), а список нужен ДО загрузки страницы, чтобы отсеять неверный
 * раздел через `notFound()`. Держать список внутри `pages/studio` означало бы статически
 * импортировать её код в этот роут-файл и свести на нет разбиение бандла.
 */
export const studioRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/studio/$section',
  validateSearch: studioSearchSchema,
  beforeLoad: ({ params }) => {
    if (!isStudioSection(params.section)) throw notFound()
  },
  component: lazyRouteComponent(() => import('@/pages/studio'), 'StudioPage'),
})
